import React from 'react';

export const StatusBadge = ({ status, severity, className = '' }) => {
  const value = status || severity;
  
  const getStatusClass = () => {
    switch(value?.toLowerCase()) {
      case 'critical':
        return 'badge-critical';
      case 'high':
        return 'badge-high';
      case 'medium':
        return 'badge-medium';
      case 'low':
        return 'badge-low';
      case 'completed':
        return 'badge-success';
      case 'running':
      case 'active':
        return 'badge-active';
      case 'pending':
        return 'badge-pending';
      case 'failed':
      case 'expired':
        return 'badge-failed';
      case 'expiring':
        return 'badge-warning';
      case 'inactive':
        return 'badge-inactive';
      default:
        return 'badge-default';
    }
  };

  return (
    <span className={`status-badge ${getStatusClass()} ${className}`} data-testid={`badge-${value?.toLowerCase()}`}>
      {value}
    </span>
  );
};
